const Events = {
  onSettingsLoaded: 'onSettingsLoaded',
  onMatching: 'onMatching',
  onProfileMeasurementSet: 'onProfileMeasurementSet',
  onCustomerReferenceChange: 'onCustomerReferenceChange',
};

export default Events;
